import type { Document, Inline } from '@gitbook/slate';

import { INLINE_MENTION, type InlineMentionData } from '../types';

/**
 * Return all user mentions listed in a document.
 */
export function getMentionsFromDocument(document: Document): InlineMentionData[] {
    const mentions = document.filterDescendants<Inline>(
        (node) => node.object === 'inline' && node.type === INLINE_MENTION,
        { withFragments: true }
    );
    return mentions.map((mention) => mention.data.toObject<InlineMentionData>()).toArray();
}

/**
 * Find a mention in a document.
 */
export function findMentionInDocument(
    document: Document,
    fn: (data: InlineMentionData) => boolean
): Inline | null {
    return document.findDescendant((node) => {
        if (node.object !== 'inline' || node.type !== INLINE_MENTION) {
            return false;
        }

        const mentionData = node.data.toObject<InlineMentionData>();
        return fn(mentionData);
    });
}
